import React, { useEffect, useState } from 'react'
import SOPBar from './SOPBar'
import { Modal } from 'react-bootstrap'
import AutoHeightTextarea from '../CommonComponent/AutoHeightTextarea';
import { Link } from 'react-router-dom';
import { PrivateAxios } from '../../environment/AxiosInstance';
import { ErrorMessage, SuccessMessage } from '../../environment/ToastMessage';
import { convertLinksNewLine } from '../../environment/ConvertLinks';

const YourSOP = () => {


  //==================Get SOP Bank===================//
  const [data, setData] = useState([]);
  const GetSOP = () => {
    PrivateAxios.get("/sop/get-sop")
      .then((res) => {
        if (res.data?.status) {
          setData(res.data.data)
        }
      }).catch((err) => {
        ErrorMessage("Internal server error !")
      })
  }

  useEffect(() => {
    GetSOP();
  }, [])


  const [viewSopShow, setViewSopShow] = useState(false);
  const viewSopModalClose = () => { setViewSopShow(false); }
  const viewSopModalShow = () => { setViewSopShow(true) };

  const [checkSheet, setCheckSheet] = useState({
    "attachment_file_link": "",
  });


  // edit view field

  const [isEditing, setIsEditing] = useState(false);
  const [title, setTitle] = useState("Organizational Performance");
  const [description, setDescription] = useState("It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.");
  const [links, setLinks] = useState([
    "https://www.growthh.in/",
    "https://www.growthh.in/",
    "https://www.growthh.in/",
  ]);
  const [hover, setHover] = useState(false);

  // Load from localStorage when component mounts
  useEffect(() => {
    const storedTitle = localStorage.getItem("cardTitle");
    const storedLinks = localStorage.getItem("cardLinks");
    const storedDescription = localStorage.getItem("cardDescription");

    if (storedTitle) setTitle(storedTitle);
    if (storedDescription) setDescription(storedDescription);
    if (storedLinks) setLinks(JSON.parse(storedLinks));
  }, []);

  // Save to localStorage when user clicks "Save"
  const handleSave = () => {
    localStorage.setItem("cardTitle", title);
    localStorage.setItem("cardDescription", description);
    localStorage.setItem("cardLinks", JSON.stringify(links));
    setIsEditing(false);
  };

  const handleEdit = () => setIsEditing(true);

  const handleChange = (index, newValue) => {
    const updatedLinks = [...links];
    updatedLinks[index] = newValue;
    setLinks(updatedLinks);
  };

  //================================Add Sop Bank====================================//
  const [addSopShow, setAddSopShow] = useState(false);
  const addSopModalClose = () => { setAddSopShow(false); }
  const addSopModalShow = () => { setAddSopShow(true) };
  const [error, setError] = useState('');
  const [sopData, setSopData] = useState({
    "title": "",
    "description": "",
    "link": ""
  })

  const submitData = (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());
    PrivateAxios.post('/sop/add-sop', data)
      .then((res) => {
        SuccessMessage(res.data.message);
        addSopModalClose();
        setData(prev => [...prev, res.data.data]);
      }).catch((err) => {
        if (!err.response?.data.status) {
          const fieldErrors = {};
          err.response.data.errors?.forEach((error) => {
            if (error.path == "link") {
              fieldErrors['links'] = error.message;
            } else {
              fieldErrors[error.path] = error.message;
            }
          });
          setError(fieldErrors)
        }

      })
  }

  //================================Add Sop Bank End====================================//

  //================================Update Sop Bank====================================//

  const [editSopShow, setEditSopShow] = useState(false);
  const [editSopData, setEditSopData] = useState('');
  const editSopModalClose = () => {
    setEditSopShow(false);
    setEditSopData('');
  }
  const editSopModalShow = (data) => {
    setEditSopShow(true);
    setEditSopData(data);
  };
  const [EditError, setEditError] = useState('');
  const submitDataUpdate = (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());

    PrivateAxios.put(`/sop/update-sop/${editSopData.id}`, data)
      .then((res) => {
        SuccessMessage(res.data.message);
        editSopModalClose();
        setData(prev => prev.map(item => item.id == editSopData.id ? { ...res.data.data } : item));
      }).catch((err) => {
        if (!err.response?.data.status) {
          const fieldErrors = {};
          err.response.data.errors?.forEach((error) => {
            if (error.path == "link") {
              fieldErrors['links'] = error.message;
            } else {
              fieldErrors[error.path] = error.message;
            }
          });
          setEditError(fieldErrors)
        }

      })
  }
  //================================Update Sop Bank End====================================//







  return (
    <>
      <div className="gthh-controller-bar">
        <ul className="gth-controller-view-block">
          <SOPBar />
        </ul>
      </div>
      <div className='p-4'>
        <div className='card'>
          <div className='card-body'>
            <div className=' d-flex justify-content-center align-content-center '>
              <div>
                <img src={process.env.PUBLIC_URL + '/assets/images/empty-box.png'} alt="no-data" className="img-fluid w-100" />
                <h5 className='f-s-18 text-center mt-2'>Nothing to Show</h5>
                <button class="btn btn-info btn-sm mt-3" type="button" onClick={addSopModalShow}><i class="fas fa-plus me-2"></i>Add New SOP</button>

              </div>
            </div>
          </div>
        </div>

        {data.length > 0 ?
          data.map((item) => (
            <div
              className="card position-relative"
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              key={item.id}
            >
              {hover && !isEditing && (
                <>
                  <button
                    className=" table-action-btn position-absolute"
                    style={{ top: "10px", right: "50px" }}
                    onClick={() => editSopModalShow(item)}
                  >
                    <i class="fas fa-pencil-alt"></i>
                  </button>
                  <button class="me-1 table-action-btn position-absolute" style={{ top: "10px", right: "10px" }}><i class="fas fa-trash-alt text-exp-red"></i></button>
                </>
              )}

              <div className="card-body">
                {/* {isEditing ? (
                  <> */}
                {/* <div className='form-group'>
                      <label className='form-label'>Title</label>
                      <input
                        type="text"
                        className="form-control mb-2"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </div>
                    <div className='form-group'>
                      <label className='form-label'>Description</label>
                      <textarea class="form-control mb-2" id="exampleFormControlTextarea1" value={description} onChange={(e) => handleChange(e.target.value)}></textarea>
                    </div>

                    <div className='form-group'>
                      <label className='form-label'>Your links</label>
                      {links.map((link, index) => (
                        <>
                          <textarea key={index} class="form-control mb-2" id="exampleFormControlTextarea1" value={link} onChange={(e) => handleChange(index, e.target.value)}></textarea>
                         
                        </>
                      ))}
                    </div>

                    <button className="btn btn-success btn-sm" onClick={handleSave}>
                      Save
                    </button>
                  </>
                ) : ( */}
                {/* <> */}
                <h5 className="mb-3">{item.title}</h5>
                <p className='f-s-16'>{item.description}</p>
                {/* {links.map((link, index) => ( */}
                {/* <p className="f-s-16 mb-2">
                  <i className="fas fa-link me-2"></i> */}
                {/* <div className="fw-semibold"> */}
                {item?.link && convertLinksNewLine(item.link)}
                {/* </div> */}
                {/* </p> */}
                {/* ))} */}
                {/* </>
                )} */}
              </div>
            </div>
          )) : ""
        }
      </div>





      {/* //====================== Create SOP=======================// */}

      <Modal
        show={addSopShow}
        onHide={addSopModalClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton className="gth-blue-light-bg">
          <Modal.Title className="gth-modal-title">Add New SOP </Modal.Title>
        </Modal.Header>
        <form onSubmit={submitData}>
          <Modal.Body>
            <div className='w-100' >
              <div className='row align-items-center'>
                <div className='col-12'>
                  <div className='form-group'>
                    <label className='form-label'>Title</label>
                    <input type='text' className="form-control" name='title' placeholder='Enter Task Name' />
                    {error.title && <span className="field-invalid"><i class="fas fa-exclamation-triangle me-1"></i>{error.title}</span>}
                  </div>

                </div>
                <div className='col-12'>
                  <div className='form-group'>
                    <label className='form-label'>Description</label>
                    <textarea type='text' className='form-control' name='description' placeholder='Write your note here...' rows={4} ></textarea>
                    {error.description && <span className="field-invalid"><i class="fas fa-exclamation-triangle me-1"></i>{error.description}</span>}
                  </div>

                </div>
                <div className='col-12'>
                  <div className='form-group'>
                    <label className='form-label'>Your links</label>
                    <AutoHeightTextarea required placeholder="Your links"
                      value={sopData.link}
                      name="link"
                      onChange={(e) =>
                        setSopData({
                          ...sopData,
                          link: e.target.value
                        })
                      }
                    />
                    {error.links && <span className="field-invalid"><i class="fas fa-exclamation-triangle me-1"></i>{error.links}</span>}
                    <p className='mb-0 mt-1 f-s-12'>

                      <i className='fas fa-info-circle me-1 text-info'></i>
                      Press enter for add more links
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className=''>
            <button className='btn btn-exp-green' type='submit'>
              Save
            </button>

          </Modal.Footer>
        </form>
      </Modal>
      {/* //====================== Create SOP End=======================// */}
      {/* //====================== Update SOP=======================// */}
      <Modal
        show={editSopShow}
        onHide={editSopModalClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton className="gth-blue-light-bg">
          <Modal.Title className="gth-modal-title">Edit New SOP </Modal.Title>
        </Modal.Header>
        <form onSubmit={submitDataUpdate}>
          <Modal.Body>
            <div className='w-100' >
              <div className='row align-items-center'>
                <div className='col-12'>
                  <div className='form-group'>
                    <label className='form-label'>Title</label>
                    <input type='text' className="form-control" name='title' defaultValue={editSopData.title} placeholder='Enter Task Name' />
                    {error.title && <span className="field-invalid"><i class="fas fa-exclamation-triangle me-1"></i>{error.title}</span>}
                  </div>

                </div>
                <div className='col-12'>
                  <div className='form-group'>
                    <label className='form-label'>Description</label>
                    <textarea type='text' className='form-control' name='description' placeholder='Write your note here...' rows={4} defaultValue={editSopData.description} ></textarea>
                    {error.description && <span className="field-invalid"><i class="fas fa-exclamation-triangle me-1"></i>{error.description}</span>}
                  </div>

                </div>
                <div className='col-12'>
                  <div className='form-group'>
                    <label className='form-label'>Your links</label>
                    <AutoHeightTextarea required placeholder="Your links"
                      defaultValue={editSopData.link}
                      name="link"
                      onChange={(e) =>
                        setSopData({
                          ...sopData,
                          link: e.target.value
                        })
                      }
                    />
                    {error.links && <span className="field-invalid"><i class="fas fa-exclamation-triangle me-1"></i>{error.links}</span>}
                    <p className='mb-0 mt-1 f-s-12'>

                      <i className='fas fa-info-circle me-1 text-info'></i>
                      Press enter for add more links
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className=''>
            <button className='btn btn-exp-green' type='submit'>
              Update
            </button>

          </Modal.Footer>
        </form>
      </Modal>

    </>
  )
}

export default YourSOP